import Http from "../utils/http" ;
export const UserService = {
    login : (params:object)=>{
        return Http.post(`auth/login/`,params);
    }
}